import { useDcRoles } from '@/hooks/use-dc-roles.ts';
import useConfig from '@/hooks/useConfig.ts';
import { usePvsUserRoles } from '@/hooks/usePvsUserRoles.ts';

import { SelectionOption } from '@/models/SelectionOption.ts';
import { PVSProvider } from '@/models/customers/PVSProvider.ts';

import { getFallbackRoleOptions } from '@/utils/filter-utils.ts';

interface RoleOptionsHook {
    roleOptions: SelectionOption[];
}

/** Role options for the task role filter and create-task picker, scoped to Doc-Cirrus instances. */
export const useRoleOptions = (): RoleOptionsHook => {
    const { instance_ids: instanceIds, config_record: configRecord } = useConfig();
    const { pvs_user_roles: pvsUserRoles } = usePvsUserRoles();

    const dcInstanceIds = instanceIds.filter((id) => configRecord[id]?.pvs_provider === PVSProvider.DOC_CIRRUS);

    const { roles: dcRoles } = useDcRoles(dcInstanceIds);

    const roleOptions = dcRoles.length > 0 ? dcRoles : getFallbackRoleOptions(pvsUserRoles, dcInstanceIds);

    return { roleOptions };
};
